export function lerp(a: number, b: number, t: number) {
    return a * (1 - t) + b * t;
}

export function getDigitAtPosition(n: number, pos: number) {
    return Math.floor((n / Math.pow(10, pos))) % 10;
}
